export const pluginId = 'neo4j-techdocs';
